/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ weeks: NonNullable<unknown>, volumeText: NonNullable<unknown> }} Wrapped_Volume_Best_WasInputs */

const en_us2_wrapped_volume_best_was = /** @type {(inputs: Wrapped_Volume_Best_WasInputs) => LocalizedString} */ (i) => {
	if ((i?.weeks === 1 || i?.weeks === "1")) return /** @type {LocalizedString} */ (`The strongest is still last week, with ${i?.volumeText}.`);
	return /** @type {LocalizedString} */ (`The strongest is still ${i?.weeks} weeks back, with ${i?.volumeText}.`)
	
};

const pt_br2_wrapped_volume_best_was = /** @type {(inputs: Wrapped_Volume_Best_WasInputs) => LocalizedString} */ (i) => {
	if ((i?.weeks === 1 || i?.weeks === "1")) return /** @type {LocalizedString} */ (`A mais forte ainda foi na semana passada, com ${i?.volumeText}.`);
	return /** @type {LocalizedString} */ (`A mais forte ainda foi há ${i?.weeks} semanas, com ${i?.volumeText}.`)
	
};

const es_419_wrapped_volume_best_was = /** @type {(inputs: Wrapped_Volume_Best_WasInputs) => LocalizedString} */ (i) => {
	if ((i?.weeks === 1 || i?.weeks === "1")) return /** @type {LocalizedString} */ (`La más fuerte sigue siendo la semana pasada, con ${i?.volumeText}.`);
	return /** @type {LocalizedString} */ (`La más fuerte sigue siendo la de hace ${i?.weeks} semanas, con ${i?.volumeText}.`)
	
};

const pt_pt2_wrapped_volume_best_was = /** @type {(inputs: Wrapped_Volume_Best_WasInputs) => LocalizedString} */ (i) => {
	if ((i?.weeks === 1 || i?.weeks === "1")) return /** @type {LocalizedString} */ (`A mais forte continua a ser a semana passada, com ${i?.volumeText}.`);
	return /** @type {LocalizedString} */ (`A mais forte continua a ser a de há ${i?.weeks} semanas, com ${i?.volumeText}.`)
	
};

const fr_fr2_wrapped_volume_best_was = /** @type {(inputs: Wrapped_Volume_Best_WasInputs) => LocalizedString} */ (i) => {
	if ((i?.weeks === 1 || i?.weeks === "1")) return /** @type {LocalizedString} */ (`La plus forte reste la semaine dernière, avec ${i?.volumeText}.`);
	return /** @type {LocalizedString} */ (`La plus forte reste celle d'il y a ${i?.weeks} semaines, avec ${i?.volumeText}.`)
	
};

const de_de2_wrapped_volume_best_was = /** @type {(inputs: Wrapped_Volume_Best_WasInputs) => LocalizedString} */ (i) => {
	if ((i?.weeks === 1 || i?.weeks === "1")) return /** @type {LocalizedString} */ (`Die stärkste bleibt die letzte Woche, mit ${i?.volumeText}.`);
	return /** @type {LocalizedString} */ (`Die stärkste liegt weiter ${i?.weeks} Wochen zurück, mit ${i?.volumeText}.`)
	
};

const it_it2_wrapped_volume_best_was = /** @type {(inputs: Wrapped_Volume_Best_WasInputs) => LocalizedString} */ (i) => {
	if ((i?.weeks === 1 || i?.weeks === "1")) return /** @type {LocalizedString} */ (`La più forte resta quella scorsa, con ${i?.volumeText}.`);
	return /** @type {LocalizedString} */ (`La più forte resta quella di ${i?.weeks} settimane fa, con ${i?.volumeText}.`)
	
};

/**
* | weeks | output |
* | --- | --- |
* | "1" | "The strongest is still last week, with {volumeText}." |
* | * | "The strongest is still {weeks} weeks back, with {volumeText}." |
*
* @param {Wrapped_Volume_Best_WasInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const wrapped_volume_best_was = /** @type {((inputs: Wrapped_Volume_Best_WasInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wrapped_Volume_Best_WasInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_wrapped_volume_best_was(inputs)
	if (locale === "es-419") return es_419_wrapped_volume_best_was(inputs)
	if (locale === "pt-PT") return pt_pt2_wrapped_volume_best_was(inputs)
	if (locale === "fr-FR") return fr_fr2_wrapped_volume_best_was(inputs)
	if (locale === "de-DE") return de_de2_wrapped_volume_best_was(inputs)
	if (locale === "it-IT") return it_it2_wrapped_volume_best_was(inputs)
	return en_us2_wrapped_volume_best_was(inputs)
});
export { wrapped_volume_best_was as "wrapped.volume_best_was" }